import { camelCase, upperFirst } from 'lodash'

// Change Boolean Helper
export function changeBool(self, key) {
  self[key] = !self[key]
}

// snake_case to PascalCase
export const snakeToPascal = str => upperFirst(camelCase(str))

// Punct to slash
export const punctToSlash = str => str.replace(/\./g, '/')

// object_type to type
export function objectTypeToType(object_type) {
  // if object_type is combined parent.children object, return only last children
  return object_type.indexOf('.') > -1 ? object_type.split('.').pop() : object_type
}

// clean object
// TODO: Can that be removed? Use lodash on checkout page
export function cleanSource(source) {
  // using native JSON functions removes reactivity
  // so we can clone an object without mutating the original source
  return JSON.parse(JSON.stringify(source))
}

// TODO: display the modal with vue?
export function toggleModal(name, title, html) {
  // eslint-disable-next-line
  $.modal({
    name: name,
    title: title,
    html: html,
  })
}

export function toggleBodyClass(className) {
  const el = document.body

  if (el.classList.contains(className)) {
    el.classList.remove(className)
  } else {
    el.classList.add(className)
  }
}

export function toggleHtmlClass(className) {
  const el = document.getElementsByTagName('html')[0]

  if (el.classList.contains(className)) {
    el.classList.remove(className)
  } else {
    el.classList.add(className)
  }
}

export function findInArray(array, value) {
  return array && array.find(ele => ele === value)
}
